import * as types from "../../actions/ActionTypes"; 
const initialState = {
    loading: false,
    data: null,
    error: null,
};

const getBusinessReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_BUSINESS_START:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case types.GET_BUSINESS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case types.GET_BUSINESS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default getBusinessReducer;
